export default {"src":"/_next/static/media/stepper-menu.9f29c156.svg","height":5,"width":8,"blurWidth":0,"blurHeight":0};